<template>
  <div>
    <div>
      <RateConnectEligibleBanner @openVideo="openVideo" :isRateConnectEligible="isRateConnectEligible" />
    </div>
  </div>
</template>
<script setup>
import RateConnectEligibleBanner from '@/components/homePage/rateConnect/RateConnectEligibleBanner.vue'

const emit = defineEmits(['openVideo'])
const openVideo = () => emit('openVideo')

defineProps({
  isRateConnectEligible: Boolean,
})
</script>
